import { useState, useEffect } from "react";
import { Navbar, Container, Nav } from "react-bootstrap";

import navIcon1 from '../assets/img/nav-icon1.svg';
import navIcon2 from '../assets/img/nav-icon2.svg';

export const NavBar = () => {
    const [activeLink, setActiveLink] = useState('home');
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => {
            if (window.scrollY > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        }

        window.addEventListener("scroll", onScroll);
        return () => { window.removeEventListener("scroll", onScroll); }
    }, []);

    const onUpdateActiveLink = (value) => {
        setActiveLink(value);
    }

    return (
        <Navbar collapseOnSelect expand="md" className={scrolled ? "scrolled" : ""}>
            <Container>
                <Navbar.Brand href="#home"><h1>NSD</h1></Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" ></Navbar.Toggle> 

                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto my-2 my-lg-0" style={{ maxHeight: '90px' }} navbarScroll >
                        <Nav.Link href="#home" className={activeLink === 'home' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('home')}>Home</Nav.Link>
                        <Nav.Link href="#projects" className={activeLink === 'projects' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('projects')}>Tech Projects</Nav.Link>
                        <Nav.Link href="#skills" className={activeLink === 'skills' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('skills')}>Stack</Nav.Link>
                        <Nav.Link href="https://www.behance.net/nrubioh" target="_blank" rel="noreferrer" className={activeLink === 'design-portfolio' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('design-portfolio')} >Design Portfolio </Nav.Link>
                    </Nav>
                <span className="navbar-text">
                    <div className="social-icon">
                        <a href="https://www.linkedin.com/in/nicolasrubioh/" target="_blank" rel="noreferrer"><img src={navIcon1} alt="" /></a>
                        <a href="https://github.com/nrubioh" target="_blank" rel="noreferrer"><img src={navIcon2} alt="" /></a>
                    </div>

                    <button className="vvg" onClick={() => window.open("https://github.com/nrubioh/resume_nicolas-rubio", "_blank")}>Link CV</button>
                </span>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}